module.exports = __webpack_public_path__ + "img/BE0402487939.185d95a8.png";